import { ReactNode } from "react";

import { Select } from "@narmi/design_system";

import styles from "./CardSelector.module.scss";

export interface MobileCardSelectorProps {
  cardId: API.CardId;
  cards: API.Card[];
  onChange: (id: API.CardId) => void;
}

const MAX_CARD_NAME_LENGTH = 25;

const MobileCardSelector = ({
  cardId,
  cards,
  onChange,
}: MobileCardSelectorProps): ReactNode => (
  <div className={styles.container}>
    <Select
      label="Card"
      value={cardId}
      onChange={onChange as (cardId: string) => void}
      disabled={cards.length === 0}
    >
      {cards.map((card) => {
        const cardName =
          card.name.length > MAX_CARD_NAME_LENGTH
            ? `${card.name.slice(0, MAX_CARD_NAME_LENGTH)}...`
            : card.name;
        return (
          <Select.Item key={card.id} value={card.id}>
            {`${cardName} - ${card.last_four_digits}`}
          </Select.Item>
        );
      })}
    </Select>
  </div>
);

export default MobileCardSelector;
